import { render, staticRenderFns } from "./labelHidden-editor.vue?vue&type=template&id=1958f579&scoped=true"
import script from "./labelHidden-editor.vue?vue&type=script&lang=js"
export * from "./labelHidden-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958f579",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1958f579')) {
      api.createRecord('1958f579', component.options)
    } else {
      api.reload('1958f579', component.options)
    }
    module.hot.accept("./labelHidden-editor.vue?vue&type=template&id=1958f579&scoped=true", function () {
      api.rerender('1958f579', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/labelHidden-editor.vue"
export default component.exports